<template>
  <v-container fluid>
    <v-tabs v-model="currentTab" dark class="pl-3 pr-3">
      <v-tabs-slider></v-tabs-slider>
      <v-tab
        v-for="tabConfig in tabsConfig"
        :key="tabConfig.name"
        :href="`#${tabConfig.name}`"
      >
        {{ tabConfig.label }}
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="currentTab" dark>
      <v-tab-item
        v-for="tabConfig in tabsConfig"
        :key="tabConfig.name"
        :value="tabConfig.name"
      >
        <v-card flat style="background-color: #272b30">
          <component :is="tabConfig.component" />
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </v-container>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import Events from "../EventManagement/Events/events.vue";
import StallHolders from "../EventManagement/Stallholders/stallholders.vue";
import Stall from "../EventManagement/Stalls/stalls.vue";
import Terminals from "../EventManagement/Terminals/terminals.vue";
import Users from "../EventManagement/Users/users.vue";
import Vouchers from "../EventManagement/Vouchers/vouchers.vue";
import Devices from "../EventManagement/Devices/devices.vue";

export default {
  components: {
    Events,
    StallHolders,
    Stall,
    Terminals,
    Users,
    Vouchers,
    Devices,
  },
  data() {
    return {
      tabsConfig: [
        { name: "Events", label: "Events", component: "Events" },
        {
          name: "Stallholders",
          label: "Stallholders",
          component: "StallHolders",
        },
        { name: "Users", label: "Users", component: "Users" },
        { name: "Stalls", label: "Stalls", component: "Stall" },
        { name: "Terminals", label: "Terminals", component: "Terminals" },
        { name: "Vouchers", label: "Vouchers", component: "Vouchers" },
        { name: "Devices", label: "Devices", component: "Devices" },
      ],
    };
  },
  computed: {
    ...mapState("admin", ["currentEventManagementTab"]),
    currentTab: {
      get() {
        return this.currentEventManagementTab;
      },
      set(value) {
        this.setCurrentEventManagementTab(value);
      },
    },
  },
  methods: {
    ...mapMutations("admin", ["setCurrentEventManagementTab"]),
  },
};
</script>

<style scoped>
body {
  background-color: #272b30;
}
h1 {
  color: #a09c94;
  font-family: sans-serif;
}
p {
  color: #6e6e6e;
  font-family: sans-serif;
}
</style>
